var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrackingError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E84F4F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5852 13.4139C14.3662 12.6329 15.6325 12.6329 16.4136 13.4139L20.4998 17.5001L24.5859 13.4139C25.367 12.6329 26.6333 12.6329 27.4144 13.4139C28.1954 14.195 28.1954 15.4613 27.4144 16.2423L23.3282 20.3285L27.4958 24.4961C28.2768 25.2771 28.2768 26.5435 27.4958 27.3245C26.7147 28.1056 25.4484 28.1056 24.6673 27.3245L20.4998 23.1569L16.3322 27.3245C15.5511 28.1056 14.2848 28.1056 13.5038 27.3245C12.7227 26.5435 12.7227 25.2771 13.5038 24.4961L17.6713 20.3285L13.5852 16.2423C12.8041 15.4613 12.8041 14.195 13.5852 13.4139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackingError);
export default __webpack_public_path__ + "static/media/tracking-error.b77eebe9dca7591f3c15bcc0d2c88eee.svg";
export { ForwardRef as ReactComponent };